import React from "react";

import img1 from "../img/The begin of a grimoire&&---Blending textures over AI generated images on Adobe Photoshop___2025-06[[6]].jpg"

export default function Machine_3() {
  return (
    <div className="panel-block">

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="PUERTA 3 · AUTHORIZED NARRATIVE INPUT"
        />
      </div>

      <div className="panel-container-right">
        <h2>AUTHORIZED NARRATIVE INPUT</h2>

      <p>
    Not everything the Machine observes<br />
    is meant to remain sealed.
  </p>

  <p>
    Some documents are released.
  </p>

  <p>
    Not to clarify.<br />
    To test.
  </p>

  <p>
    These are not stories.<br />
    They are authorized fragments<br />
    of an ongoing calibration.
  </p>

  <p>
    What you read here<br />
    has passed through the Black Box.
  </p>

  <p>
    Not all of it returns intact.
  </p>
      </div>

    </div>
  );
}
